import React, { useState, useRef, useEffect } from "react";
import clpLogo from "../../resources/ClassplusLogo.png";
import { male, maleAppView, female, femaleAppView } from "../../utils/tecahersCard";
import html2canvas from "html2canvas";
import uploadToS3 from "../../uploadToS3";

import downloadCTA from "../../resources/DownloadCTA.png";
import whatsappCTA from "../../resources/shareWa.png";
import shareSocialCTA from "../../resources/shareSocialCTA.png";
import snapChat from "../../resources/snapchatCta.png";
import sendToTeacher from "../../resources/sentToTeacher.png";
import whatsapp from "../../resources/whatsapp.png";
import facebook from "../../resources/facebook.png";
import dot from "../../resources/dotsWEB.png";
import telegram from "../../resources/telegram.png";
import copy from "../../resources/copy.png";

import copyMem from "../../resources/copymem.png";
import telegramBlue from "../../resources/telegramblue.png";

import { Button, Form, Input } from "semantic-ui-react";

import "./memoryOutput.css";

const MemoryOutput = (props) => {
  const [toggleSheet, settoggleSheet] = useState(false);
  const [teacherNumber, setTeacherNumber] = useState("");
  const [imgUrl, setImgUrl] = useState();
  const [uploadImg, setUploadImg] = useState();
  const [disabled, setDisabled] = useState(true);

  const [ isToken, setisToken ] = useState(false)

  const [creativeUrl, setCretiveUrl] = useState();
  // console.log(creativeUrl, "has data")

  let { studentName, teachersName, friendName, imageKey, mobileNumber, type, className } = props.location.state;
  console.log(className, "classname")
  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);

  const utmSource =  localStorage.getItem('utmSource')

  const utmMedium = localStorage.getItem("utmMedium");
  const utmCampaign = localStorage.getItem("utmCampaign");
  const [shareUrl, setShareUrl] = useState('');
  const [fbShareLink, setfbShareLink] = useState('');
  const [mainShareUrl, setMainShareUrl] = useState('https://classplusapp.com/classwalidosti');

  let textShare = `Hi, yaad hai hum class mae saath kaise masti krte the? Maine hamari masti ki ek bht sundar memory create ki hai. Click here to see hamari class wali dosti ki memory ${mainShareUrl} and meri tarah tum bhi koi memory create karo.

Aaj saare group ko dikhate hai hamari class wali masti 😜`
  useEffect(() => {
    


var fbShareLink = `Hi, yaad hai jb hum class mae yeh kiya krte the. 
Meri tarah, tum bhi apni khud ki 
#ClassWaliDosti post bana skte ho`;


    setShareUrl(textShare)
    setfbShareLink(fbShareLink)
  }, [])

  useEffect(() => {
    


    var fbShareLink = `Hi, yaad hai jb hum class mae yeh kiya krte the. 
    Meri tarah, tum bhi apni khud ki 
    #ClassWaliDosti post bana skte ho`;
    
    
        setShareUrl(textShare)
        setfbShareLink(fbShareLink)
      }, [mainShareUrl])
    

  useEffect(() => {
    if (uploadImg) {
      console.log("use effect");
      uploadToS3([uploadImg])
        .then((resp) => setCretiveUrl(resp[0].url))

    }


  }, [uploadImg]);

  useEffect(() => {
    if (creativeUrl) {
      handleAddApi()
    }
  }, [creativeUrl])

  const handleAddApi = async () => {

    let body = {
      teacherName: teachersName,
      studentName: studentName,
      creativeId: imageKey,
      studentNumber: mobileNumber,
      friendName: friendName,
      creativeUrl: creativeUrl,
      utmSource,
      utmMedium,
      utmCampaign,
    };

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
    await fetch(
      "https://multiverse-api.classplusapp.com/ts/teachersday/add-teacher",
      requestOptions
    ).then((response) => response.json()).then(response => {
      console.log('response', response)
      setMainShareUrl(response.data.shortUrl)
    });
  };

  useEffect(() => {
    if (!uploadImg) {
      makeBlobToShare();
    }
  }, []);

  useEffect(() => {
    if (teacherNumber.length > 1) {
      setDisabled(false);
    }
    if (teacherNumber.length > 10) {
      setTeacherNumber(teacherNumber.slice(0, 10));
    }
  }, [teacherNumber]);


  useEffect(() => {
    if(sessionStorage.getItem("token")){
      setisToken(true)
   
    }
    
}, [])


  function copyText() {
    // var text = document.getElementById("copyBlock").innerText;
    var elem = document.createElement("textarea");
    document.body.appendChild(elem);
    // elem.value = `Hi, yaad hai jb hum class mae yeh kiya krte the. Meri tarah, tum bhi
    // apni khud ki #ClassWaliDosti post bana skte ho - https://classplusapp.com/classwalidosti`;
    elem.value = shareUrl;
    elem.select();
    document.execCommand("copy");
    document.body.removeChild(elem);

    var x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(function () {
      x.className = x.className.replace("show", "");
    }, 3000);
  }

  const shareOnWASocialmedia = () => {

    var container = document.getElementById("output-card-display");
    let textShare = `Hi, yaad hai hum class mae saath kaise masti krte the? Maine hamari masti ki ek bht sundar memory create ki hai. Click here to see hamari class wali dosti ki memory ${mainShareUrl} and meri tarah tum bhi koi memory create karo.

Aaj saare group ko dikhate hai hamari class wali masti 😜`

    html2canvas(container, { allowTaint: true }).then(async function (canvas) {

      canvas.toBlob((blob) => {


        var file = new File([blob], "picture.jpg", { type: "image/jpeg" });
        var filesArray = [file];

        // if (navigator.canShare && navigator.canShare({ files: filesArray })) {
        if (navigator.canShare && navigator.canShare({ files: filesArray })) {
          navigator
            .share({
              files: filesArray,
              title: "Pictures",
              text: shareUrl
            })
            .then(() => console.log("Share was successful."))
            .catch((error) => console.log("Sharing failed", error));
        } else {
          var link = document.createElement("a");
          document.body.appendChild(link);
          link.download = "Poster.png";
          link.href = canvas.toDataURL("image/png");
          link.target = '_blank';
          link.click();
          console.log(`Your system doesn't support sharing files.`);
          window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareUrl)}`)
        }


      });


    });



  };

  const shareOnTGSocialmedia = () => {

    var container = document.getElementById("output-card-display");
    let textShare = `Hi, yaad hai hum class mae saath kaise masti krte the? Maine hamari masti ki ek bht sundar memory create ki hai. Click here to see hamari class wali dosti ki memory ${mainShareUrl} and meri tarah tum bhi koi memory create karo.

Aaj saare group ko dikhate hai hamari class wali masti 😜`

    html2canvas(container, { allowTaint: true }).then(async function (canvas) {

      canvas.toBlob((blob) => {


        var file = new File([blob], "picture.jpg", { type: "image/jpeg" });
        var filesArray = [file];

        // if (navigator.canShare && navigator.canShare({ files: filesArray })) {
        if (navigator.canShare && navigator.canShare({ files: filesArray })) {
          navigator
            .share({
              files: filesArray,
              title: "Pictures",
              text: shareUrl
            })
            .then(() => console.log("Share was successful."))
            .catch((error) => console.log("Sharing failed", error));
        } else {
          var link = document.createElement("a");
          document.body.appendChild(link);
          link.download = "Poster.png";
          link.href = canvas.toDataURL("image/png");
          link.target = '_blank';
          link.click();
          console.log(`Your system doesn't support sharing files.`);
          window.open(`https://telegram.me/share/url?text=${encodeURIComponent(shareUrl)}`)
        }


      });


    });



  };

  // const shareOnWatsapp = () => {
  //   let message = `Dear Teacher, 

  // Thank you for everything you've taught me. Apki class mae maine bht se concepts seekhe aur memories banayi.Thank you for everything. ☺

  // I miss being in your classroom. Unhi memories mae sae ek hai yeh ${window.location.href} 

  // Thank you`;

  //   window.location.href = `https://api.whatsapp.com/send?text=${encodeURIComponent(
  //     message
  //   )}`;
  // };

  const makeBlobToShare = () => {
    function dataURItoBlob(dataURI) {
      var binary = atob(dataURI.split(",")[1]);
      var array = [];
      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
    }
    var container = document.getElementById("output-card-display");

    html2canvas(container, { allowTaint: true }).then(async function (canvas) {
      var link = document.createElement("a");
      document.body.appendChild(link);
      link.download = "Poster.png";
      link.href = canvas.toDataURL("image/png");
      var blobData = dataURItoBlob(link.href);
      blobData.name = "abc.png";
      setUploadImg(blobData);
    });
  };

  // const imageClass = `${(type == "male") ? 'm':'f'}${className}`
  return (
    <>
      <div id="output-page">
        <div id="navbar">
          <img src={clpLogo} id="navbar-clpLogo" />
        </div>

        <div id="output-card-display">
          {props.location.state ? (
            <>
              <img
                src={
                  type == "male" ? (

                    isToken ? maleAppView[props.location.state.imageKey].secondImg :

                    male[props.location.state.imageKey].secondImg
                    ) :
                    type == "female" ? (
                      isToken ? maleAppView[props.location.state.imageKey].secondImg:
                      female[props.location.state.imageKey].secondImg 
                    ):
                      ""

                }
                id="output-card-img"
              />
              <div
                className={`studentName-display studentName-display-${className}`}
              >
                {props.location.state.studentName}
              </div>
              <div
                className={`studentName-display studentName-display-${className}-2`}
              >
                {props.location.state.studentName}
              </div>
              <div
                className={`teacherName-display teacherName-display-${className}`}
              >
                {props.location.state.teachersName}
              </div>
              <div
                className={`friendName-display friendName-display-${className}`}
              >
                {props.location.state.friendName}
              </div>
            </>
          ) : (
            ""
          )}
        </div>
        <div id="share-memory-block">
          <div id="memory-ready">Aapki #ClassWaliDosti memory is ready!</div>

          <div id="share-with-world">
          Take a screenshot ya share karien yeh memory abhi apne sabhi doston aur teachers ke saath, don’t forget to crop the image :P
          </div>
          {/* <div id="copyBlock">
            Hi, yaad hai jb hum class mae yeh kiya krte the. Meri tarah, tum bhi
            apni khud ki #ClassWaliDosti post bana skte ho
            <div id="copyBtn">
              <img
                src={copy}
                id="copyImage"
                onClick={() => {
                  copyText();
                }}
              />
            </div>
          </div> */}
        </div>
        <img
            src={whatsappCTA}
            id="whatsapp-cta"
            onClick={() => shareOnWASocialmedia()}
          />
        <div id="output-cta-block">

          <img
            src={copyMem}
            id="shareSocial-cta"
            onClick={() => copyText()}
          />
          <img 
          src={telegramBlue}
          onClick={() => shareOnTGSocialmedia()}
          id="shareSocial-cta"/>
        </div>
        <div id="snackbar">Text copied</div>
      </div>
    </>
  );
};

export default MemoryOutput;
